import { useTranslation } from 'react-i18next';
import Stat from './stat';
import { Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

function AvgPriceStat({ data }) {
  const {t} = useTranslation()

  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );

  return (
    <Col
      className={classNames('col-md-6 mt-0', {
        'opacity-25': isNoPeriodData
      })}
    >
      <Stat
        icon={'coin'}
        mainLabel={t('ticketStatistic.avgPrice')}
        smallLabel={t('ticketStatistic.avgPriceDescription')}
        value={data.averageTicketPrice}
        currency={data.currency}
      />
    </Col>
  );
}

export default AvgPriceStat
